import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Space, Tooltip, Button } from 'antd';
import { Link } from 'react-router-dom';

import {
  DATA_INDEX,
  EDIT_MESSAGE_TEMPLATE_PATH,
  KEY,
  MESSAGE,
  TITLE,
} from '@app/constants';

import type { PassTableHeaderType } from '@pages/Messages/MessageTemplatesRegistry/MessageTemplatesRegistry.types';

export const passTableHeader: PassTableHeaderType = (
  setIsDeletionWindowOpen,
  setActiveTemplateId
) => {
  return [
    {
      [TITLE]: <span data-testid="template-name-title">Название</span>,
      [DATA_INDEX]: 'Name',
      [KEY]: TITLE,
      render: (value, { Name }) => (
        <div
          className="MessageTemplatesRegistry__cell-text"
          data-testid="template-name"
        >
          {Name}
        </div>
      ),
    },
    {
      [TITLE]: <span data-testid="template-message-title">Сообщение</span>,
      [DATA_INDEX]: MESSAGE,
      [KEY]: MESSAGE,
      render: (value, { Message }) => (
        <div
          className="MessageTemplatesRegistry__cell-text"
          data-testid="template-message"
        >
          {Message}
        </div>
      ),
    },
    {
      [TITLE]: '',
      [KEY]: 'action',
      render: (value, { Id }) => (
        <Space size="small">
          <Tooltip title="Редактировать шаблон" placement="bottomLeft">
            <Link to={`${EDIT_MESSAGE_TEMPLATE_PATH}?id=${Id}`}>
              <Button icon={<EditOutlined />} data-testid="edit-template" />
            </Link>
          </Tooltip>

          <Tooltip title="Удалить шаблон" placement="bottomLeft">
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => {
                setActiveTemplateId(Id);
                setIsDeletionWindowOpen(true);
              }}
              data-testid="delete-template"
            />
          </Tooltip>
        </Space>
      ),
      width: 80,
    },
  ];
};
